<nav class="sidebar" [class.sidebar-mode]="isSidebarMode" [class.disabled]="!isAuthenticated">
  <div class="sidebar-content">
    <div class="nav-items">
      <ng-container *ngFor="let item of navigationItems">
        <!-- Separator -->
        <div *ngIf="item.label === 'separator'" class="nav-separator"></div>
        
        <!-- Regular nav item -->
        <div 
          *ngIf="item.label !== 'separator'"
          [routerLink]="isAuthenticated && item.route ? item.route : null"
          [routerLinkActive]="item.route && isAuthenticated ? 'active' : ''"
          #rla="routerLinkActive"
          (click)="onItemClick(item)"
          [class.clickable]="item.action && isAuthenticated"
          [class.active]="item.action === 'new' && showNewMenu"
          [class.disabled]="!isAuthenticated"
          class="nav-item">
          <mat-icon class="nav-icon" 
                    [svgIcon]="(rla.isActive && item.iconActive) || (item.action === 'new' && showNewMenu && item.iconActive) ? item.iconActive : (item.icon.includes('-') ? item.icon : '')" 
                    [attr.data-icon]="!item.icon.includes('-') ? item.icon : null">
            {{ !item.icon.includes('-') ? item.icon : '' }}
          </mat-icon>
          <span class="nav-label">{{ item.label }}</span>
          
          <!-- New Menu Dropdown -->
          <div class="new-menu-dropdown" *ngIf="item.action === 'new' && showNewMenu" (click)="$event.stopPropagation()">
            <button class="new-menu-item" (click)="onNewMenuItemClick('new-datasource')">
              <mat-icon svgIcon="data-set-blue" class="menu-item-icon"></mat-icon>
              <span>New Datasource</span>
            </button>
            <div class="new-menu-separator"></div>
            <button class="new-menu-item" (click)="onNewMenuItemClick('profile-data')">
              <mat-icon svgIcon="chart-blue" class="menu-item-icon"></mat-icon>
              <span>Data Assessment</span>
            </button>
            <button class="new-menu-item" (click)="onNewMenuItemClick('anomaly-detection')">
              <mat-icon svgIcon="radar-ai-blue" class="menu-item-icon"></mat-icon>
              <span>Detect Anomalies</span>
            </button>
            <button class="new-menu-item" (click)="onNewMenuItemClick('ai-readiness')">
              <mat-icon svgIcon="ai-brain-idea-blue" class="menu-item-icon"></mat-icon>
              <span>AI Readiness</span>
            </button>
            <button class="new-menu-item" (click)="onNewMenuItemClick('clean-data')">
              <mat-icon svgIcon="ai-scan-blue" class="menu-item-icon"></mat-icon>
              <span>Clean Data</span>
            </button>
            <!-- HYPOTHESIS TESTING - COMMENTED OUT -->
            <!-- <button class="new-menu-item" (click)="onNewMenuItemClick('hypothesis-testing')">
              <mat-icon svgIcon="ai-brain-idea-blue" class="menu-item-icon"></mat-icon>
              <span>Hypothesis Testing</span>
            </button> -->
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</nav>
